const state = {
  entries: [],
  server: null,
  error: null
}

const getters = {
  pvpBanlistEntries: state => state.entries,
  pvpBanlistServer: state => state.server,
  pvpBanlistError: state => state.error
}

const actions = {
  getPvpBanlist ({ commit }, payload) {
    commit('setPvpBanlist', payload)
  },
  setError ({ commit }, payload) {
    commit('setError', payload.data)
  }
}

const mutations = {
  setPvpBanlist (state, payload) {
    state.entries = (payload.data && payload.data.data) ? payload.data.data : []
    state.server = payload.data ? payload.data.server : null
    state.error = null
  },
  setError (state, error) {
    state.error = { error, time: Date.now() }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
